import draftToHtml from 'draftjs-to-html'
import type { RawDraftContentState } from 'draft-js'

export function parseRichTextContent(richText: string | undefined) {
  const parsedContent = JSON.parse(richText ?? '') as RawDraftContentState

  return draftToHtml(parsedContent)
}
